/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsDimensions, FxIdDomainSettingsDimensionsFromJSONTyped, FxIdDomainSettingsDimensionsToJSON, } from './FxIdDomainSettingsDimensions';
export function FxIdDomainSettingsPresentationOptionsMinRatioFromJSON(json) {
    return FxIdDomainSettingsPresentationOptionsMinRatioFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsMinRatioFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsDimensions(json)) {
        return FxIdDomainSettingsDimensionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPresentationOptionsMinRatioToJSON(json) {
    return FxIdDomainSettingsPresentationOptionsMinRatioToJSONTyped(json, false);
}
export function FxIdDomainSettingsPresentationOptionsMinRatioToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsDimensions(value)) {
        return FxIdDomainSettingsDimensionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPresentationOptionsMinRatio.js.map